import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Dedication } from './order-dedication-types'

const INITIAL_STATE: Dedication = {
  // basic fields
  type: 'honor',
  honoreeName: '',
  honoreeFirstName: '',
  honoreeLastName: '',

  // email fields
  recipientName: '',
  recipientFirstName: '',
  recipientLastName: '',
  recipientEmailAddress: '',

  // printed card fields
  recipientAddress: '',
  recipientCity: '',
  recipientState: '',
  recipientPostalCode: '',
  recipientCountry: '',

  // ecard fields
  ecardMessage: '',
  ecardId: undefined,

  // notification fields
  sendEmail: false,
  addEmailEcard: false,
  sendPrintedCard: false,

  // other fields
  hasDedication: false,
  isGiftAmountMessageIncluded: false,
}

const orderDedicationSlice = createSlice({
  name: 'dedication',
  initialState: INITIAL_STATE,
  reducers: {
    setValue: (_state, action: PayloadAction<Dedication>) => action.payload,
    clearValue: () => INITIAL_STATE,
  },
})

export default orderDedicationSlice
